import React, { Component } from 'react';
import { connect } from "react-redux";
import {setPatternToEditColor} from 'actions/index.js';
import {setPatternColor} from 'actions/index.js';

class SubToolbar extends Component {
    constructor(props) {
        super(props);
        this.onClickColor = this.onClickColor.bind(this);
    }

    onClickColor(color) {
        console.log('pattern to edit color = ' + this.props.patternToEditColor);
        this.props.setPatternColor(this.props.patternToEditColor, color);
    }

    onClickDone() {
        this.props.setPatternToEditColor(undefined);
    }

    render() {
        return (
            <div className="sub-toolbar">
              <div className="color-picker">
                <ColorOption patternColor={this.props.patternColor} color="white" onClickColor={this.onClickColor}></ColorOption>
                <ColorOption patternColor={this.props.patternColor} color="red" onClickColor={this.onClickColor}></ColorOption>
                <ColorOption patternColor={this.props.patternColor} color="orange" onClickColor={this.onClickColor}></ColorOption>
                <ColorOption patternColor={this.props.patternColor} color="yellow" onClickColor={this.onClickColor}></ColorOption>
                <ColorOption patternColor={this.props.patternColor} color="green" onClickColor={this.onClickColor}></ColorOption>
                <ColorOption patternColor={this.props.patternColor} color="blue" onClickColor={this.onClickColor}></ColorOption>
                <ColorOption patternColor={this.props.patternColor} color="purple" onClickColor={this.onClickColor}></ColorOption>
              </div>
              <div className="done-button" onClick={() => this.onClickDone()}>
                DONE
              </div>
            </div>
        );
    }
}

class ColorOption extends Component {
    render() {
        let className="color-option background-" + this.props.color;

        if (this.props.patternColor === this.props.color) {
            className += ' selected';
        }

        return (
            <div
              onClick={() => this.props.onClickColor(this.props.color)}
              className={className}>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setPatternToEditColor: pattern => dispatch(setPatternToEditColor(pattern)),
        setPatternColor: (pattern, color) => dispatch(setPatternColor(pattern, color)),
    };
};

const mapStateToProps = state => {
    return {
        patternToEditColor: state.toolbar.patternToEditColor,
        patternColor: state.toolbar.patternColors[state.toolbar.patternToEditColor],
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SubToolbar);
